import { Flex } from 'components'
import { ExplorerMoment } from 'types'
import { useEvent } from '../../../utils/eventUtils'
import TemplateOverrides from './TemplateOverrides'

interface Props {
  value: ExplorerMoment
  onChange: (moment: ExplorerMoment) => void
}

export default function ManageExplorerMoment({ value, onChange }: Props) {
  const { event } = useEvent()

  if (!event) return null

  function handleChange(body: Partial<ExplorerMoment>) {
    onChange({ ...value, ...body })
  }

  const { template } = value

  return (
    <Flex direction="column" gap={2}>
      <TemplateOverrides
        partialTemplate={template}
        onUpdate={v => handleChange({ template: { ...template, ...v } })}
      />
    </Flex>
  )
}
